import { isActionableFactForUi } from './factsPanelUtils';

/** Pick an email on the business domain for ownership proof (mirrors publishHandlers registrableDomainFromBrief). */
export function defaultOwnershipEmail(brief) {
  if (!brief) return '';
  const contact = brief.contact || {};
  const candidates = [];
  if (typeof contact.email === 'string') candidates.push(contact.email);
  if (Array.isArray(contact.emails)) {
    for (const e of contact.emails) {
      const addr = typeof e === 'string' ? e : e?.address;
      if (typeof addr === 'string') candidates.push(addr);
    }
  }
  for (const raw of candidates) {
    if (!raw.includes('@')) continue;
    const dom = raw.split('@')[1]?.trim().toLowerCase();
    if (dom && !/^(gmail|yahoo|hotmail|outlook)\./.test(dom)) return raw.trim();
  }
  for (const raw of candidates) {
    if (raw.includes('@')) return raw.trim();
  }
  return '';
}

export function ownershipVerified(ownership) {
  if (!ownership) return false;
  if (ownership.adminOverride?.by) return true;
  return Boolean(ownership.verifiedEmail);
}

/** Same rule as publishHandlers allFactsConfirmed (every fact path, not collapsed FAQ rows). */
export function allFactPathsConfirmed(facts, confirmedFactPaths, brief) {
  const paths = [...new Set((facts || []).filter((f) => isActionableFactForUi(f, brief)).map((f) => f.path))];
  if (!paths.length) return false;
  const confirmed = new Set(confirmedFactPaths || []);
  return paths.every((p) => confirmed.has(p));
}

export function domainReady(domain) {
  return domain?.status === 'active' && typeof domain?.host === 'string';
}

export function domainStatusLabel(status) {
  if (status === 'active') return 'Connected and ready';
  if (status === 'pending_dns' || status === 'pending') return 'Waiting on DNS. Add the CNAME, then check again.';
  if (status === 'issuing') return 'Issuing certificate. Check again in a minute.';
  return 'Not connected yet';
}

/** FEEDBACK 60: never show paths or stack traces from API errors in the publish flow. */
export function ownerFacingPublishError(message) {
  const raw = message || 'Something went wrong.';
  if (/ENOENT|no such file|\.json|\/Users\/|node_modules/i.test(raw)) {
    return 'Publish failed. Try again in a moment.';
  }
  if (/\/Users\/|at .*\.(?:js|ts):\d+/i.test(raw)) {
    return 'Publish failed. Try again in a moment.';
  }
  if (raw.length > 200) return 'Publish failed. Try again in a moment.';
  return raw;
}

/** Header Publish button tooltip (FEEDBACK 37): what still blocks going live. */
export function publishHeaderTooltip({
  editorLoaded,
  allFactsConfirmed,
  ownership,
  domain,
  publishOpen,
}) {
  if (!editorLoaded) return 'Loading site…';
  if (publishOpen) return 'Close publish panel';
  const blockers = [];
  if (!allFactsConfirmed) blockers.push('confirm every fact');
  if (!ownershipVerified(ownership)) blockers.push('prove ownership with the email code');
  if (!domainReady(domain)) blockers.push('connect your domain');
  if (blockers.length === 0) return 'Publish your site';
  return `Before you publish: ${blockers.join(', ')}`;
}
